import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from "vue";
import ChipsInput from './ChipsInput.vue'

type ValueType = string;
type ItemType = {
  text: string,
  secondaryText?: string,
  value?: string
};


export default /*#__PURE__*/_defineComponent({
  __name: 'ChipsSelect',
  props: {
    placeholder: { default: '' },
    allSelector: { default: '' },
    menuItems: null,
    emptyStateTitle: null,
    emptyStateText: null,
    value: null
  },
  emits: ["input", "select", "removed"],
  setup(__props: any, { emit }: { emit: ({
  (e: "input", value?: Array<ValueType>): void;
  (e: "select", value: string): void;
  (e: "removed", value: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { placeholder: string, allSelector: string, menuItems: Array<ItemType>, emptyStateTitle: string, emptyStateText: string, value?: Array<ValueType> };





const inputValue = ref('');
const filteredItems = computed(() => props.menuItems.filter(mi => mi.text.toLowerCase().startsWith(inputValue.value.toLowerCase())));
const menuOpen = ref(false);

const items = computed({
  get: () => props.value,
  set: (newValue) => emit('input', newValue)
});

function change(value: string) {
  inputValue.value = value
}

function selectItem(item: ItemType) {
  items.value = props.value && (props.value.some(si => si === item.text) ?
    props.value.filter(si => si !== item.text) :
    props.value.concat(item.text));

  menuOpen.value = false;
  inputValue.value = '';
  if (item.value) {
    emit('select', item.value);
  }
}

function selectAll() {
  items.value = props.menuItems.map(mi => mi.text)
  menuOpen.value = false;
  inputValue.value = '';
}

function onClickOutside() {
  menuOpen.value = false;
  inputValue.value = '';
}

function input(itemsProp?: Array<string>) {
  items.value = itemsProp && itemsProp.filter((i: ValueType) => props.menuItems.find(mi => mi.text === i));
}


return { __sfc: true,props, emit, inputValue, filteredItems, menuOpen, items, change, selectItem, selectAll, onClickOutside, input, ChipsInput }
}

})